<template><div><h1>VUX V2.2.1Rc.1 发布日志</h1>
<h2><a href="/zh-CN/components/cell-box.html">CellBox</a></h2>
<ul><li>[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙</li>
</ul>
<h2><a href="/zh-CN/components/cell-form-preview.html">CellFormPreview</a></h2>
<ul><li>[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持 prop:border-intent, 用以不显示边框与左边间隙</li>
<li>[feature] 支持 prop:arrow-direction, 用以在折叠场景下动态更改方向</li>
</ul>
<h2><a href="/zh-CN/components/checklist.html">Checklist</a></h2>
<ul><li>[feature] 支持 prop:check-disabled</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[fix] 修复错误的弹窗关闭类型 #1209</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1Rc.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-rc.1-219.vue?2a0eec9c